module.exports = __webpack_public_path__ + "static/img/news-video2.a017917.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blast/news-video2.jpg
// module id = NNE2
// module chunks = 1